export default "# Output:Table:Annual\n\nNo special algorithms were employed to implement the Output:Table:Annual object.\n"